import { paths } from 'client/shared/Paths';
import { PermissionLabel } from 'client/generated/graphql';

export const SIGNED_OUT_LINKS = [
  {
    type: 'link',
    label: 'Features',
    key: 'features',
    to: paths.anchor.features,
  },
  {
    type: 'link',
    label: 'Switch to Anchor',
    key: 'switch',
    to: paths.anchor.switch,
  },
  {
    type: 'link',
    label: 'Ads by Anchor',
    key: 'ads',
    to: paths.anchor.ads,
  },
  {
    type: 'link',
    label: 'Blog',
    key: 'blog',
    href: paths.blog.home,
    openInNewTab: true,
  },
];

// These are normally in the footer, but for narrow screens, we only keep Legal there.
export const SECONDARY_MOBILE_LINKS = [
  {
    type: 'link',
    label: 'Careers',
    key: 'careers',
    href: paths.spotify.jobs.creationPlatform,
    target: '_blank',
  },
  {
    type: 'link',
    label: 'Help',
    key: 'help',
    href: paths.getHelpPage('home'),
    target: '_blank',
  },
];

// TODO: add back episodes link when the episodes page is ready
export const SIGNED_IN_LINKS = [
  {
    type: 'link',
    label: 'Network',
    key: 'network',
    to: '/dashboard/network',
  },
  {
    type: 'link',
    label: 'Dashboard',
    key: 'dashboard',
    to: '/dashboard',
    // The /dashboard route will eventually be
    // replaced with /dashboard/analytics when
    // Scalable Analytics launches in May 22.
    // Adding the permission to both routes in the
    // interim for testing purposes
    permission: [PermissionLabel.AnalyticsView],
  },
  {
    type: 'link',
    label: 'Episodes',
    key: 'episodes',
    to: '/dashboard/episodes',
    permission: [PermissionLabel.EpisodeView],
  },
  {
    type: 'link',
    label: 'Money',
    key: 'money',
    to: '/dashboard/money',
    notificationBadge: 'DollarSignIcon',
    permission: [PermissionLabel.RevenueView],
  },
];

export const ACCOUNT_MENU_ITEMS = [
  {
    type: 'link',
    label: 'Update settings',
    icon: {
      type: 'GearIcon',
      iconColor: '#c9cbcd',
      backgroundColor: 'transparent',
      width: 18,
      padding: 0,
    },
    to: '/dashboard/podcast/edit',
  },
  {
    type: 'link',
    label: 'Help',
    icon: {
      type: 'QuestionMarkIcon',
      iconColor: '#ffffff',
      backgroundColor: 'gray',
      width: 18,
      padding: 3,
    },
    target: '_blank',
    href: paths.getHelpPage('home'),
  },
];
